import { render, staticRenderFns } from "./MyPageInterest.vue?vue&type=template&id=bee5d102&scoped=true"
import script from "./MyPageInterest.vue?vue&type=script&lang=js"
export * from "./MyPageInterest.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bee5d102",
  null
  
)

export default component.exports